import { Link } from 'react-router-dom';
import { sectors } from '../pages/sectors/sectorsData';
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
  const { isEN, t } = useLanguage();
  const year = new Date().getFullYear();
  const noop = (e) => e.preventDefault();

  return (
    <footer className="footer">
      <div className="footer-glow"></div>
      <div className="wrap">
        <div className="footer-grid">
          <div>
            <Link className="brand" to="/">
              <span className="brand-logo">
                <img className="brand-logo__white" src="/assets/logo-white.png" alt={isEN ? 'Elhaware Group' : 'مجموعة الهواري'} />
                <img className="brand-logo__color" src="/assets/logo-c.png" alt={isEN ? 'Elhaware Group' : 'مجموعة الهواري'} />
              </span>
              <span className="brand-name">{isEN ? 'Elhaware Group' : 'مجموعة الهواري'}<span>EST. 2015</span></span>
            </Link>
            <p style={{ marginTop: 20, maxWidth: '38ch', color: 'rgba(231,236,223,.6)', fontSize: 15 }}>
              {isEN
                ? 'An integrated economic entity built on agricultural investment, livestock production, and agro-manufacturing.'
                : 'كيان اقتصادي متكامل الأنشطة، قائم على الاستثمار الزراعي والإنتاج الحيواني والتصنيع الزراعي.'}
            </p>
          </div>
          <div>
            <h4>{isEN ? 'Quick Links' : 'روابط'}</h4>
            <ul>
              <li><Link to="/">{isEN ? 'Home' : 'الرئيسية'}</Link></li>
              <li><Link to="/about">{isEN ? 'About' : 'من نحن'}</Link></li>
              <li><Link to="/" state={{ scrollTo: 'sectors' }}>{isEN ? 'Sectors' : 'القطاعات'}</Link></li>
              <li><Link to="/" state={{ scrollTo: 'global' }}>{isEN ? 'International Branches' : 'الفروع الخارجية'}</Link></li>
              <li><Link to="/contact">{isEN ? 'Contact Us' : 'اتصل بنا'}</Link></li>
            </ul>
          </div>
          <div>
            <h4>{isEN ? 'Sectors' : 'القطاعات'}</h4>
            <ul>
              {sectors.map((s) => (
                <li key={s.slug}><Link to={s.route}>{t(s.navLabel)}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4>{isEN ? 'Contact' : 'تواصل'}</h4>
            <ul>
              <li><a href="mailto:abeermomtaz@elhawaregroup.com" dir="ltr" style={{ display: 'inline-block' }}>abeermomtaz@elhawaregroup.com</a></li>
              <li><a href="mailto:info@elhawaregroup.com" dir="ltr" style={{ display: 'inline-block' }}>info@elhawaregroup.com</a></li>
              <li><a href={`https://wa.me/201222113013?text=${encodeURIComponent(isEN ? 'Hello Elhaware Group, I would like to know more about your products and services.' : 'مرحباً مجموعة الهواري، أودّ معرفة المزيد عن منتجاتكم وخدماتكم.')}`} target="_blank" rel="noopener noreferrer" dir="ltr" style={{ display: 'inline-block' }}>+20 122 211 3013</a></li>
              <li><a href={`https://wa.me/201096978144?text=${encodeURIComponent(isEN ? 'Hello Elhaware Group, I would like to know more about your products and services.' : 'مرحباً مجموعة الهواري، أودّ معرفة المزيد عن منتجاتكم وخدماتكم.')}`} target="_blank" rel="noopener noreferrer" dir="ltr" style={{ display: 'inline-block' }}>+20 109 697 8144</a></li>
              <li style={{ color: 'rgba(231,236,223,.6)' }}>{isEN ? '13 Al Ahly Bank Building · Sphinx Square · 8th Floor · Mohandeseen · Giza · Egypt' : '13 مبنى البنك الأهلي · ميدان سفنكس · الدور الثامن · المهندسين · الجيزة · مصر'}</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© <span>{year}</span> {isEN ? 'Elhaware Group — All rights reserved.' : 'مجموعة الهواري — جميع الحقوق محفوظة.'}</span>
          <span style={{ display: 'flex', gap: 20 }}>
            <a href="#terms" onClick={noop}>{isEN ? 'Terms & Conditions' : 'الشروط والأحكام'}</a>
            <a href="#privacy" onClick={noop}>{isEN ? 'Privacy Policy' : 'سياسة الخصوصية'}</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
